import React, { useEffect } from 'react';
import { Translation } from 'react-i18next';
import useWindowDimensions from '../../../../../lib/WindowDimensions';
import Logger from '../../../../../lib/Logger';
import LearningModuleCardLarge from '../containers/LearningModuleCardLargeContainer';
import LearningModuleCardShort from '../containers/LearningModuleCardShortContainer';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const settings = {
  dots: false,
  infinite: false,
  slidesToShow: 3,
  slidesToScroll: 3,
  initialSlide: 0,
  className: 'learning-module-list-slider-container',
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        dots: false,
      },
    },
    {
      breakpoint: 1600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: false,
        dots: false,
      },
    },
  ],
};

const LearningModuleList = ({
  activeId,
  moduleSerieId,
  selectedTags,
  debouncedQuery,
  load,
  list,
  action,
  value,
  state,
  ...props
}) => {
  const { width } = useWindowDimensions();
  const isMedium = 768 <= width;

  useEffect(() => {
    const filter = { [action]: value };

    if (state.length > 0) {
      filter['state'] = state.join(',');
    }

    if (debouncedQuery.trim() !== '') {
      filter['keyword'] = debouncedQuery;
    }

    if (selectedTags.length > 0) {
      filter['categories'] = selectedTags.join(',');
    }

    load(activeId, moduleSerieId, action, filter);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    activeId,
    moduleSerieId,
    action,
    debouncedQuery,
    selectedTags,
    load,
    state,
  ]);

  return (
    <Translation>
      {(t) => (
        <>
          {isMedium ? (
            <>
              {list.length < 3 && (
                <div className='learning-module-list-unique-container'>
                  {list.map((x) => (
                    <LearningModuleCardLarge item={x} />
                  ))}
                </div>
              )}

              <div>
                {list.length > 1 && list.length !== 2 && list.length !== 1 && (
                  <div className='slider-container'>
                    <Slider {...settings}>
                      {list.map((x) => (
                        <LearningModuleCardShort item={x} />
                      ))}
                    </Slider>
                  </div>
                )}
              </div>
            </>
          ) : (
            <>
              {list.length < 2 && (
                <>
                  <div className='learning-module-list-container-mobile'>
                    {list.map((x) => (
                      <LearningModuleCardShort item={x} />
                    ))}
                  </div>
                </>
              )}

              <div>
                {list.length > 1 && (
                  <div className='slider-container'>
                    <Slider {...settings}>
                      {list.map((x) => (
                        <LearningModuleCardShort item={x} />
                      ))}
                    </Slider>
                  </div>
                )}
              </div>
            </>
          )}
        </>
      )}
    </Translation>
  );
};

export default LearningModuleList;

Logger.log('silly', `LearningModuleList loaded.`);
